// src/pages/HomePage.js
import api from '../api/axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import SEO from '../components/SEO';

// Import the new view components
import HomePageDesktop from './HomePage.desktop';
import HomePageMobile from './HomePage.mobile';

// --- Data Section ---

// Animation variants for Framer Motion
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
};

// Default "Why Us" Section Data (used as a fallback)



function HomePage() {
  // useEffect(() => {
  //     api.get('/sync_xero_users').catch((err) => console.error('Failed to fetch inventory:', err));
  // }, []);
  const navigate = useNavigate();
  const location = useLocation();

  // --- Immediate Redirect for Logged In Users ---
  const token = localStorage.getItem('accessToken');
  useEffect(() => {
    // Only redirect if NOT an intentional visit (via Home button)
    if (token && !location.state?.intentional) {
      navigate('/browse', { replace: true });
    }
  }, [token, navigate, location.state]);

  // --- State for UI control ---
  const [isMobile, setIsMobile] = useState(false);
  const [isSpeedDialOpen, setSpeedDialOpen] = React.useState(false);
  const [stepperOpen, setStepperOpen] = useState(false);

  // --- State for the support form ---
  const [issue, setIssue] = useState('');
  const [orderId, setOrderId] = useState('');
  const [details, setDetails] = useState('');

  // --- Handlers ---
  const handleSpeedDialOpen = () => setSpeedDialOpen(true);
  const handleSpeedDialClose = () => setSpeedDialOpen(false);

  const handleStepperOpen = () => setStepperOpen(true);
  const handleStepperClose = () => {
    // Reset form on close
    setIssue('');
    setOrderId('');
    setDetails('');
    setStepperOpen(false);
  };

  const onStepperCompleted = () => {
    console.log("Form Submitted:", { issue, orderId, details });
    handleStepperClose();
    navigate('/care'); // Navigate to the new page on completion
  };

  // --- Effect to check screen size ---
  useEffect(() => {
    const checkIsMobile = () => {
      const mobileBreakpoint = 900; // Adjusted breakpoint for better tablet handling
      setIsMobile(window.innerWidth < mobileBreakpoint);
    };
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // --- Data that depends on handlers ---
  const contactActions = [
    { icon: <PhoneIcon />, name: 'Contact Customer Care', action: handleStepperOpen },
  ];

  // --- Props to pass to view components ---
  const viewProps = {
    navigate,
    containerVariants,
    itemVariants,

    contactActions,
    isSpeedDialOpen,
    handleSpeedDialOpen,
    handleSpeedDialClose,
    stepperOpen,
    handleStepperClose,
    onStepperCompleted,
    issue,
    setIssue,
    orderId,
    setOrderId,
    details,
    setDetails,
  };

  if (token && !location.state?.intentional) return null; // Render nothing if logged in to prevent flash

  return (
    <>
      <SEO
        title="Matax Express | Wholesale Grocery & Fresh Produce Supplier Toronto"
        description="Toronto's trusted wholesale grocery supplier. Premium fresh fruits, vegetables & produce delivered to restaurants, grocery stores & businesses 7 days a week."
        keywords="wholesale grocery Toronto, fresh produce supplier, restaurant food supplier, B2B grocery delivery, fruits vegetables wholesale GTA"
        url="https://mataxexpress.ca/"
      />
      {isMobile ? <HomePageMobile {...viewProps} /> : <HomePageDesktop {...viewProps} />}
    </>
  );
}

export default HomePage;